export default {
  computed: {
    passwordsMatchErrorMessage() {
      if (this[this.prefix].password == this[this.prefix].confirmedPassword) {
        return []
      }
      return [
        'Passwords do not match!'
      ]
    },
  }
}